import type { AddressesDto } from './address.dto';

export type AddressViewModel = {
  address: string;
  placeId: string;
};

export const toAddressViewModel = (dto: AddressesDto): AddressViewModel[] => {
  return dto.options.map((option) => ({
    address: option.full_address,
    placeId: option.place_id,
  }));
};
